import { MY_CONTENT_MUTATIONS_NAMES } from '@/app/private/my-content/store/my-content.store';
import { RequestProvider } from '@/shared/providers/request.provider';

class ContentActions {

  ACTIONS = {
    GET_CONTENT: 'getContent',
    REMOVE_CONTENT: 'removeContent'
  };
  
  getContent(ctx, { type = '', code = '', builderContent = []}) {
    const page = ctx.state.pageName;
    const contentType = page === 'create' || page === 'subjects' ? 'drafts' : page;
    const userParam = page === 'purchased' ? 'userId' : 'authorId'; 
    const authorId = ctx.rootState.AuthStore.user.id;
    const currentPage = ctx.state[page][type].currentPage;
    const sizePage = ctx.state[page][type].sizePage;
    return RequestProvider.get(`content/${contentType}?page=${currentPage}&pageSize=${sizePage}&${userParam}=${authorId}&type=${code}`)
      .then((res: any) => {
        ctx.commit(MY_CONTENT_MUTATIONS_NAMES.SET_CONTENT, {
          page: page === 'subjects' ? 'subjects' : page,
          type,
          content: res.content,
          totalPages: res.totalPages,
          builderContent: builderContent
        });
      }
    )
    .catch((error) => {
      ctx.commit(MY_CONTENT_MUTATIONS_NAMES.SET_CONTENT, {
        page: page === 'subjects' ? 'subjects' : page,
        type,
        content: [],
        totalPages: 1,
        builderContent: builderContent
      });
    });
  }

  removeContent(ctx, content) {
    const contentId = (content.deleteLocal) ? content.contentId : content.id;
    return RequestProvider.remove(`content/${contentId}`).then(() => {
      ctx.commit(MY_CONTENT_MUTATIONS_NAMES.REMOVE_CONTENT, content);
    });
  }

  removeContentFromStore(ctx, content) {
    ctx.commit(MY_CONTENT_MUTATIONS_NAMES.REMOVE_CONTENT, content);
  }

  getContentStatusById(ctx, contentId) {
    return RequestProvider.get(`content/course/${contentId}`).then((contentResponse) => {
      ctx.commit(MY_CONTENT_MUTATIONS_NAMES.UPDATE_CONTENT_STATUS, { 
        page: 'subjects',
        contentId,
        status: contentResponse.status
      });
    });
  }

}

export default new ContentActions();